<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="" style="position: relative">
                  <CalendarRange
                    v-model="searchParams.date"
                    :disabled="disabledDatePicker"
                    mode="date"
                    @input="onDatePickerChange"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng tháng' }}
                </div>
                <!-- <div class="flex align-center">
                  <el-date-picker
                    v-model="month"
                    type="month"
                    placeholder="Vui lòng chọn"
                  >
                  </el-date-picker>
                  <div class="date-divide"></div>
                  <el-date-picker
                    v-model="month"
                    type="month"
                    placeholder="Vui lòng chọn"
                  >
                  </el-date-picker>
                </div> -->

                <div class="">
                  <el-date-picker
                    v-model="searchParams.monthRange"
                    type="monthrange"
                    start-placeholder="Tháng bắt đầu"
                    end-placeholder="Tháng kết thúc"
                    :disabled="disabledMonthPicker"
                    @change="onMonthPickerChange"
                  >
                    <template #range-separator>
                      <div class="date-divide"></div>
                    </template>
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label" style="visibility: hidden">
                  {{ 'includeHUInPercentOcc' }}
                </div>
                <div
                  style="
                    background: #f0f0f5;
                    padding: 0 8px;
                    margin: 0;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                  "
                >
                  <div class="checkbox-wrap">
                    <input
                      id="foc"
                      v-model="searchParams.foc"
                      type="checkbox"
                    />
                    <label for="foc" style="color: #606266; font-size: 14px">{{
                      'Hiển thị FOC'
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo tổng hợp doanh thu phòng` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              dom-layout="scroll"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Ngày:</li>
            <li>FO: Front Office</li>
            <ul>
              <li>Tiền phòng</li>
              <li>
                Dịch vụ khác: Hiển thị số tiền các dịch vụ được khách yêu cầu
                thêm ví dụ : Muốn trang trí phòng. rượu trong phòng.....
              </li>
            </ul>
            <li>
              Buồng phòng: Hiên thị số tiền các dịch vụ buồng phòng: được cấu
              hình tại nhóm dịch vụ buồng phòng
            </li>
            <li>
              Nhà hàng: Hiển thị số tiền các dịch vụ ăn uống mà khách sử dụng
            </li>
            <li>
              Dịch vụ: Chia cột theo các dịch vụ: Dịch vụ đặc biệt: như Spa,
              Karaoke...
            </li>
            <li>Vé: Hiển thị số tiền khách đã mua các loại vé</li>
            <li>Thành tiền: tổng số tiền của Tất cả các loại dịch vụ trên</li>
            <li>Đã thanh toán:</li>
            <ul>
              <li>
                Với những ngày trong quá khứ khách đã sử dụng dịch vụ: => Đã
                thanh toán= tiền cọc + Tiền thanh toán thêm
              </li>
              <li>
                Với những ngày trong tương lai khách chưa sử dụng dịch vụ => Đã
                thanh toán = Tiền cọc
              </li>
            </ul>
            <li>Chưa thanh toán= Thành tiền - Đã thanh toán</li>
            <li style="font-weight: bold">Lưu ý</li>
            <ul>
              <li>Phòng FOC tổng tiền = 0, tất cả các loại dịch vụ = 0</li>
              <li>
                Phòng cancel/ Noshow = > Tiền Phòng = 0, đã thanh toán = tiền
                cọc
              </li>
              <li>
                Với những cột là số tiền: tự động hiển thị dấu phẩy phân tách.
                Ví dụ: 100000(1 trăm) hiển thị: 100,000
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
/* eslint-disable */

import DownloadBtn from './components/DownloadBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import NoteDialog from './components/NoteDialog.vue'

import { getAllHotel } from '@/api/hotel'
import {
  getRevenueReport,
  getRevenueReportExcel
} from '@/api/report_service/datntReport'

import { formatVND } from '@/utils/commonUtils'

export default {
  components: { DownloadBtn, CalendarRange, NoteDialog },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: {
        monthRange: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null,
        foc: true,
        hotelIds: null
      },
      defaultSearchParams: {
        monthRange: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null,
        foc: true,
        hotelIds: null
      },

      // data for search
      hotelList: [],

      // grid
      columns: [
        {
          headerName: 'Ngày',
          field: 'date',
          headerClass: 'header-row-span-2',
          minWidth: 130,
          maxWidth: 130
        },
        {
          headerName: 'FO',
          headerClass: 'header-cell-center',
          children: [
            {
              headerName: 'Tiền phòng',
              field: 'room_money',
              cellRenderer: params => formatVND(params.data.room_money, null),
              cellClass: 'ag-cell-right',
              minWidth: 100
            },
            {
              headerName: 'Dịch vụ khác',
              field: 'special_service',
              cellRenderer: params =>
                formatVND(params.data.special_service, null),
              minWidth: 100,
              cellClass: 'ag-cell-right'
            },
            {
              headerName: 'Phụ phí',
              field: 'surcharge',
              cellRenderer: params => formatVND(params.data.surcharge, null),
              minWidth: 100,
              cellClass: 'ag-cell-right'
            },
            {
              headerName: 'Karaoke + Spa',
              field: 'karaoke_spa',
              cellRenderer: params => formatVND(params.data.karaoke_spa, null),
              headerClass: 'last-header-cell-group',
              minWidth: 100,
              cellClass: 'ag-cell-right'
            }
          ]
        },
        {
          headerName: 'Buồng phòng',
          field: 'chamber',
          cellRenderer: params => formatVND(params.data.chamber, null),
          minWidth: 100,
          cellClass: 'ag-cell-right',
          headerClass: [
            'header-row-span-2',
            'header-cell-suffix-group',
            'header-cell-center'
          ]
        },
        {
          headerName: 'Nhà hàng',
          field: 'restaurant',
          headerClass: 'header-cell-center',
          cellRenderer: params => formatVND(params.data.restaurant, null),
          cellClass: 'ag-cell-right',
          minWidth: 100,
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Vé',
          field: 'ticket',
          minWidth: 100,
          cellRenderer: params => formatVND(params.data.ticket, null),
          headerClass: [
            'header-row-span-2',
            'header-cell-suffix-group',
            'header-cell-center'
          ],
          cellClass: 'ag-cell-right'
        },
        {
          headerName: 'Thành tiền',
          minWidth: 100,
          field: 'total_money',
          cellRenderer: params => formatVND(params.data.total_money, null),
          cellClass: 'ag-cell-right',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Đã thanh toán',
          minWidth: 100,
          field: 'paid',
          cellRenderer: params => formatVND(params.data.paid, null),
          cellClass: 'ag-cell-right',
          headerClass: ['header-cell-center', 'header-row-span-2']
        },
        {
          headerName: 'Chưa thanh toán',
          minWidth: 100,
          field: 'unpaid',
          cellRenderer: params => formatVND(params.data.unpaid, null),
          cellClass: 'ag-cell-right',
          headerClass: ['header-row-span-2', 'header-cell-center']
        },
        {
          headerName: 'Hoàn tiền',
          minWidth: 100,
          field: 'refund',
          cellRenderer: params => formatVND(params.data.refund, null),
          cellClass: 'ag-cell-right',
          headerClass: ['header-row-span-2', 'header-cell-center']
        },
        {
          headerName: 'Cọc dư',
          minWidth: 100,
          field: 'deposit_surplus',
          cellRenderer: params => formatVND(params.data.deposit_surplus, null),
          cellClass: 'ag-cell-right',
          headerClass: ['header-row-span-2', 'header-cell-center']
        }
      ],
      rows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false,

      // input
      disabledDatePicker: false,
      disabledMonthPicker: true
    }
  },

  async mounted() {
    await this.getListHotel()
    await this.fnGetRevenueReport()
  },

  methods: {
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    // handle event
    onSearch() {
      this.fnGetRevenueReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.disabledDatePicker = false
      this.disabledMonthPicker = true
      this.fnGetRevenueReport()
    },

    onDatePickerChange() {
      // console.log(this.searchParams.date)
      if (this.searchParams.date.end || this.searchParams.date.start) {
        this.disabledMonthPicker = true
      } else {
        this.disabledMonthPicker = false
      }
    },

    onMonthPickerChange() {
      // console.log(this.searchParams.monthRange)
      if (this.searchParams.monthRange === null) {
        this.disabledDatePicker = false
      } else {
        this.disabledDatePicker = true
      }
    },
    exportExcel() {
      const query = {
        foc: this.searchParams.foc,
        hotelIds: this.searchParams.hotelIds,
        dateFrom:
          this.searchParams.date?.start ||
          (this.searchParams.monthRange?.[0]
            ? this.$moment
                .utc(this.searchParams.monthRange?.[0])
                ?.add(1, 'days')
                ?.format('YYYY-MM-DD')
            : null),
        dateTo:
          this.searchParams.date?.end ||
          (this.searchParams.monthRange?.[1]
            ? this.$moment
                .utc(this.searchParams.monthRange?.[1])
                ?.add(1, 'days')
                ?.endOf('month')
                ?.format('YYYY-MM-DD')
            : null)
      }
      getRevenueReportExcel(query).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'tong_hop_doanh_thu_phong_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },

    // handle api call
    async fnGetRevenueReport() {
      try {
        const query = {
          foc: this.searchParams.foc,
          hotelIds: this.searchParams.hotelIds,
          dateFrom:
            this.searchParams.date?.start ||
            (this.searchParams.monthRange?.[0]
              ? this.$moment
                  .utc(this.searchParams.monthRange?.[0])
                  ?.add(1, 'days')
                  ?.format('YYYY-MM-DD')
              : null),
          dateTo:
            this.searchParams.date?.end ||
            (this.searchParams.monthRange?.[1]
              ? this.$moment
                  .utc(this.searchParams.monthRange?.[1])
                  ?.add(1, 'days')
                  ?.endOf('month')
                  ?.format('YYYY-MM-DD')
              : null)
        }
        const res = await getRevenueReport(query)
        this.rows = res.data.map(item => {
          if (item?.total_room_money != undefined) {
            return {
              date: 'Tổng',
              chamber: item.total_chamber,
              restaurant: item.total_restaurant,
              ticket: item.total_ticket,
              paid: item.total_paid,
              unpaid: item.total_unpaid,
              room_money: item.total_room_money,
              special_service: item.total_special_service,
              karaoke_spa: item.total_karaoke_spa,
              total_money: item.total_money,
              surcharge: item.total_surcharge,
              refund: item.total_refund,
              deposit_surplus: item.total_deposit_surplus
            }
          }
          return item
        })
        this.pinnedBottomRowData = [{ ...this.rows.pop() }]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
      }
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    }
  }
}
</script>
